import React, {Component,} from 'react';
import {Grid, Button, FormGroup, FormControl, Row, Col} from 'react-bootstrap';

import Myslider from './SilderComp';
import SearchBooks from "./SearchBooks";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import jquery from 'jquery';
import BookDetails from './BookDetails';
import ReactPaginate from 'react-paginate';
// import Paginate from './Paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './Home.css';


export default class Home extends Component {


    constructor(props) {
        super(props);
        this.state = {
            selectedOption: '',
            Highlihgts: [],
            LastMaterials: [],
            MaterialTypes: [],
            SearchResults: [],
            flagg: false,
            BookDetails: [],
            offset: 0,
            cntt: 0,
        };
        this.SearchMaterials = this.SearchMaterials.bind(this);
        this.bookDetailActivate = this.bookDetailActivate.bind(this);
        this.getDataAtIndex = this.getDataAtIndex.bind(this);
        this.getPaginate = this.getPaginate.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
    }


    getDataAtIndex() {

        this.setState({
            selectedOption: '',
            Highlihgts: [],
            LastMaterials: [],
            MaterialTypes: [],
            SearchResults: [],
            flagg: false,
            BookDetails: [],
        });


        fetch('https://ets-ws.anadolu.edu.tr/publishapi/index', {
            //fetch('http://localhost:8085/publishapi/index', {

            method: "GET",
            headers: {
                'Authorization': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJldHMtd2Vic2VydmljZXMifQ.EuhtnmabJ9H67LLgchAt6Z75oGjjIXmB3HksUYXCOeM'
            },
            credentials: "same-origin"
        }).then((Response) => Response.json())
            .then((findresponse) => {

                let allTypes = {label: 'Bütün Türler', value: '*'};
                findresponse.MaterialTypes.unshift(allTypes);

                this.setState({
                    Highlihgts: findresponse.Highlihgts,
                    MaterialTypes: findresponse.MaterialTypes,
                    LastMaterials: findresponse.LastMaterials,

                });

                if (this.state.MaterialTypes.length > 0) {
                    this.setState({selectedOption: this.state.MaterialTypes[0]});
                }


            }, function (error) {
                error.message
            });
        window.location.hash = "";


    }


    bookDetailActivate() {

        if (window.location.hash.substr(0, 11) === "#bookdetail") {
            let id = window.location.hash.substr(11);

            let idd = false;
            let res = -1;
            for (let i = 0; i < this.state.Highlihgts.length; i++) {
                if (id == this.state.Highlihgts[i].id) {
                    idd = i;
                    res = this.state.Highlihgts[i];
                }
            }

            if (idd === false) {
                for (let i = 0; i < this.state.LastMaterials.length; i++) {
                    if (id == this.state.LastMaterials[i].id) {
                        idd = i;
                        res = this.state.LastMaterials[i];
                    }
                }

            }

            if (idd === false) {
                for (let i = 0; i < this.state.SearchResults.length; i++) {
                    if (id == this.state.SearchResults[i].id) {
                        idd = i;
                        res = this.state.SearchResults[i];
                    }
                }

            }

            if (idd !== false) {

                this.setState({
                    flagg: true,
                    SearchResults: [],
                    Highlihgts: [],
                    LastMaterials: [],
                    BookDetails: res,
                });


            }
        } else if (window.location.hash.length < 4) {
            this.getDataAtIndex();
        } else if (window.location.hash.substr(0, 11) === "#booksearch") {
            this.searchBooks(window.location.hash.substr(11));
        }


    }


    componentDidMount() {


        if (window.location.hash.substr(0, 11) === "#bookdetail") {


            fetch('https://ets-ws.anadolu.edu.tr/publishapi/getbookdetail/' + window.location.hash.substr(11), {
                //     fetch('http://localhost:8085/publishapi/getbookdetail/' + window.location.hash.substr(11), {
                method: "GET",
                headers: {
                    'Authorization': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJldHMtd2Vic2VydmljZXMifQ.EuhtnmabJ9H67LLgchAt6Z75oGjjIXmB3HksUYXCOeM'
                },
                credentials: "same-origin"
            }).then((Response) => Response.json())
                .then((findresponse) => {

                    let res = {MaterialProperties: [], name: "Malzeme Bulunamadı!!!"};
                    if (findresponse.Highlihgts !== undefined && findresponse.Highlihgts !== null && findresponse.Highlihgts.length > 0) {
                        res = findresponse.Highlihgts[0];
                    }
                    let allTypes = {label: 'Bütün Türler', value: '*'};
                    findresponse.MaterialTypes.unshift(allTypes);

                    this.setState({
                        Highlihgts: [],
                        MaterialTypes: findresponse.MaterialTypes,
                        flagg: true,
                        SearchResults: [],
                        BookDetails: res,

                    });

                    if (this.state.MaterialTypes.length > 0) {
                        this.setState({selectedOption: this.state.MaterialTypes[0]});
                    }


                }, function (error) {
                    error.message
                });

        } else if (window.location.hash.substr(0, 11) === "#booksearch") {
            this.searchBooks(window.location.hash.substr(11));
        }
        else {
            this.getDataAtIndex();
        }


        let srchMts = this.SearchMaterials;


        window.addEventListener("hashchange", this.bookDetailActivate, false);
        jquery("#bContent").keyup(function (event) {
            if (event.keyCode === 13) {
                srchMts(0);
            }
        });


    }

    handleChange = (selectedOption) => {
        // console.log(selectedOption);
        this.setState({selectedOption});
    };


    searchBooks(queryy) {


        fetch('https://ets-ws.anadolu.edu.tr/publishapi/getpublishes' + queryy, {
            // fetch('http://localhost:8085/publishapi/getpublishes' + queryy, {
            method: "GET",
            headers: {
                'Authorization': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJldHMtd2Vic2VydmljZXMifQ.EuhtnmabJ9H67LLgchAt6Z75oGjjIXmB3HksUYXCOeM'
            },
            credentials: "same-origin"
        }).then((Response) => Response.json())
            .then((findresponse) => {
                if (findresponse.Punlishes === null) {
                    findresponse.Punlishes = [];
                }

                let allTypes = {label: 'Bütün Türler', value: '*'};
                findresponse.MaterialTypes.unshift(allTypes);

                // console.log("findresponse : ", findresponse);
                this.setState({
                    Highlihgts: [],
                    LastMaterials: [],
                    SearchResults: findresponse.Punlishes,
                    flagg: false,
                    cntt: findresponse.Count,
                    MaterialTypes: findresponse.MaterialTypes,
                });

                let queryvals = queryy.split('/');
                console.log(queryy, queryvals);


                if (queryvals.length >= 2 && this.state.MaterialTypes.length > 0) {
                    let mattypeind = -1;
                    let mattype = queryvals[1];


                    for (let i = 0; i < this.state.MaterialTypes.length; i++) {
                        if (this.state.MaterialTypes[i].value == mattype) {
                            mattypeind = i;

                        }
                    }


                    if (mattypeind !== -1) {
                        this.setState({selectedOption: this.state.MaterialTypes[mattypeind]});
                    }


                }


            }, function (error) {
                console.log("findresponse error: ", error);
                error.message;
            });

    }


    SearchMaterials(offsett) {


        let query = jquery('#bContent').val();
        let typee = '2';
        if (query === null || query === "") {
            typee = '1';
            query = "empty";
        }

        if (typeof(offsett) === 'object') {
            offsett = 0;
        }

        let queryy = this.state.selectedOption.value + '/' + typee + '/10/' + offsett + '/' + query;

        window.location.hash = "#booksearch/" + queryy


    }


    getSearchBar = () => {


        return (


            <Row>

                <Col md={2} sm={12} className="nopadding">
                    <Select id="aContent"
                            name="form-field-name"
                            value={this.state.selectedOption}
                            placeholder="Malzeme Türü"
                            onChange={this.handleChange}
                            options={this.state.MaterialTypes}

                    />

                </Col>


                <Col md={9} sm={12} className="nopadding">
                    <FormControl
                        id="bContent"
                        ref="bContent"
                        type="text"
                        placeholder="Kitap veya materyalin ismini yazın"
                        bsSize="sm"
                    />

                </Col>


                <Col md={1} sm={12} className="nopadding">
                    <Button id="cContent" onClick={this.SearchMaterials}><FontAwesomeIcon icon="search" /></Button>
                    {/*<Button id="cContent" onClick={this.SearchMaterials}><span id="dContent">Ara</span></Button>*/}

                </Col>


            </Row>


        )
    };


    handlePageClick(data) {
        let selected = data.selected;
        let offset = Math.ceil(selected * 10);
        // this.changeOffset(offset);
        this.SearchMaterials(offset);
    };


    getPaginate() {


        if (this.state.SearchResults.length == 0) {
            return (
                <div>

                </div>
            )
        }

        let numberOfPages = Math.ceil(this.state.cntt / 10);

        return (

            <Row>
                <Col md={12} mdOffset={6}>
                    <ReactPaginate previousLabel={"önceki"}
                                   nextLabel={"sonraki"}
                                   breakLabel={<a href="">...</a>}
                                   breakClassName={"break-me"}
                                   pageCount={numberOfPages}
                                   marginPagesDisplayed={2}
                                   pageRangeDisplayed={5}
                                   onPageChange={this.handlePageClick}
                                   containerClassName={"pagination"}
                                   subContainerClassName={"pages pagination"}
                                   activeClassName={"active"}/>


                </Col>


            </Row>


        )


    }


    render() {

        return (
            <Grid className="anasayfa">

                <br/><br/>
                {this.getSearchBar()}

                <br/><br/><br/>


                <BookDetails flagg={this.state.flagg} data={this.state.BookDetails}/>

                <Myslider header='Öne Çıkanlar' data={this.state.Highlihgts} autoplay={true}/>
                <br/><br/><br/>
                <Myslider header='Son Eklenenler' data={this.state.LastMaterials} autoplay={false}/>
                <SearchBooks data={this.state.SearchResults}/>
                <br/><br/><br/>

                {this.getPaginate()}


            </Grid>

        )
    }

}




// WEBPACK FOOTER //
// ./src/components/Home.js